module.exports = __webpack_public_path__ + "static/pension-card-16606b630b48b064eed2910d54a5bcfc.svg";